// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"2ccab0ef","325":"71177d62","516":"98f81f0f","901":"fa1c48e8","996":"f32ffc31"}[chunkId] + ".js";
};